import type { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export interface ApiErrorResponse {
  code: string;
  message: string;
  status: number;
  params?: Record<string, string | number>;
}

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError(error => {
      const apiError: ApiErrorResponse = {
        code: error.error?.error?.code ?? 'UNKNOWN_ERROR',
        message: error.error?.error?.message ?? 'An unexpected error occurred',
        status: error.status ?? 0,
        params: error.error?.error?.params ?? undefined,
      };
      return throwError(() => apiError);
    })
  );
};
